import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Feetable from "./Feetable";
import Webcam from "react-webcam";
const NewStudent = ({ feeData, concessionData }) => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [concessionRows, setConcessionRows] = useState([]);
  const MONTHLY_FEE_KEY = "Monthly Fee";
  const [selectedRouteId, setSelectedRouteId] = useState("");
  const [editCredentials, setEditCredentials] = useState(false);
const [rawRouteMonthlyFees, setRawRouteMonthlyFees] = useState(null);
const [routeMonthlyFees, setRouteMonthlyFees] = useState(null); // adjusted (final)
const [showCamera, setShowCamera] = useState(false);
const [previewImage, setPreviewImage] = useState(null);
const [deviceId, setDeviceId] = useState(null);
const [buses, setBuses] = useState([]);
  const months = [
    "April", "May", "June",
    "July", "August", "September", "October", "November", "December", "January", "February", "March"
  ];
  const [updatedFSData, setUpdatedFSData] = useState(null);
  const [overallConcessionPercent, setOverallConcessionPercent] = useState(0);
  const [overallConcessionAmount, setOverallConcessionAmount] = useState(0);
  const [feeHeadConcessions, setFeeHeadConcessions] = useState({});// { "Tuition Fee": { percent: 0, amount: 0 } }
  const [appliedConcessions, setAppliedConcessions] = useState([]);
  const [editableMonths, setEditableMonths] = useState({});
  const [selectedSection, setSelectedSection] = useState("");

const [concessionAllowed, setConcessionAllowed] = useState(true);
const [concessionMessage, setConcessionMessage] = useState("");

  const initialStudentData = {
    firstName: "",
    lastName: "",
    fatherName: "",
    motherName: "",
    phoneNo: "",
    phoneNo2: "",
    email: "",
    
    aadhaarNumber: "",
    gender: "",
    dob: "",
    age: "",
    image: null,
    state: "",
    city: "",
    address: "",
    category: "",
    financial: "",
    status: "active",
    class: "",
    section: "",
    rollNo: "",
    session: "",
    previousYearResult: "",
    feeStructureId: "",
    ledgerId: "",
    transportationMode: "",
    routeName: "",
    location: "",
    routeCharges: 0,
    routeType: "",
    username: "",
    password: "",
  };
  const [selectedFSData, setSelectedFSData] = useState(null);

  const [studentData, setStudentData] = useState(initialStudentData);
  const [classes, setClasses] = useState([]);
  const [sections, setSections] = useState([]);
  const [sessions, setSessions] = useState([]);
  const [feeStructures, setFeeStructures] = useState([]);
  const [busRoutes, setBusRoutes] = useState([]);
  const [locations, setLocations] = useState([]);
  const [existingCharges, setExistingCharges] = useState(0);
  const [loading, setLoading] = useState(false);
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedFeeStructure, setSelectedFeeStructure] = useState("");
  const [forConcession, setForConcession] = useState(false);
  const [rowConcessions, setRowConcessions] = useState({});
  const [heads, setHeads] = useState([]);
  const [selectedHead, setSelectedHead] = useState("");
//   const checkFamilyConcessionEligibility = async (familyId, sessionId) => {
//   try {
//     await axios.post(
//       `${process.env.REACT_APP_API_BASE_URL}/api/concession/check-family-eligibility`,
//       { familyId, sessionId }
//     );
//     return { allowed: true };
//   } catch (err) {
//     return {
//       allowed: false,
//       message: err.response?.data?.message || "Concession not allowed"
//     };
//   }
// };
// useEffect(() => {
//   if (!studentData.familyId || !studentData.session) {
//     setConcessionAllowed(false);
//     setConcessionMessage("");
//     return;
//   }

//   const checkEligibility = async () => {
//     const result = await checkFamilyConcessionEligibility(
//       studentData.familyId,
//       studentData.session
//     );

//     setConcessionAllowed(result.allowed);
//     setConcessionMessage(result.allowed ? "" : result.message);

//     // 🔒 auto-turn off concession UI if not allowed
//     if (!result.allowed) {
//       setForConcession(false);
//       setRowConcessions({});
//       setUpdatedFSData(null);
//     }
//   };

//   checkEligibility();
// }, [studentData.familyId, studentData.session]);
useEffect(() => {
  const sessionId = localStorage.getItem("currentSessionId");

  if (!sessionId) return;

  axios
    .get(`${process.env.REACT_APP_API_BASE_URL}/api/busdetails/getAllBusDetails`, {
      params: { sessionId }
    })
    .then(res => setBuses(res.data))
    .catch(err => console.error(err));
}, []);
useEffect(() => {
  navigator.mediaDevices.enumerateDevices().then((devices) => {
    const videoDevices = devices.filter(
      (device) => device.kind === "videoinput"
    );

    console.log("Available Cameras:", videoDevices);

    // Automatically pick laptop camera (exclude phone)
    const laptopCam = videoDevices.find(
      (device) =>
        !device.label.toLowerCase().includes("realme") &&
        !device.label.toLowerCase().includes("phone")
    );

    if (laptopCam) {
      setDeviceId(laptopCam.deviceId);
    } else if (videoDevices.length > 0) {
      setDeviceId(videoDevices[0].deviceId);
    }
  });
}, []);
const webcamRef = useRef(null);

const capturePhoto = () => {
  if (!webcamRef.current) return;

  const imageSrc = webcamRef.current.getScreenshot();
  if (!imageSrc) return;

  setPreviewImage(imageSrc);

  fetch(imageSrc)
    .then(res => res.blob())
    .then(blob => {
      const file = new File([blob], "student.jpg", { type: "image/jpeg" });
      setStudentData(prev => ({ ...prev, image: file }));
    });

  setShowCamera(false);
};
useEffect(() => {
  if (
    studentData.transportationMode !== "schoolVan" ||
    !studentData.routeName ||
    !studentData.location ||
    !studentData.session
  ) {
    setRouteMonthlyFees(null);
    return;
  }

  const fetchRouteFees = async () => {
    try {
      const res = await axios.get(
        ` ${process.env.REACT_APP_API_BASE_URL}/api/routeCharges/getRouteChargesByLocationandRoute/${studentData.routeName}/${studentData.location}`,
        {
          params: { sessionId: studentData.session }
        }
      );

      setRawRouteMonthlyFees(res.data); // always full fee
 // { month1: 190, ... }
    } catch (err) {
      console.error("Route fee fetch failed", err);
      setRouteMonthlyFees(null);
    }
  };

  fetchRouteFees();
}, [
  studentData.transportationMode,
  studentData.routeName,
  studentData.location,
  studentData.session
]);


  // Fetch sessions on mount
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/api/sessions/allSessions`)
      .then((res) => setSessions(res.data))
      .catch((err) => console.error("Error fetching sessions:", err));
  }, []);

useEffect(() => {
  if (!forConcession) {
    // Reset everything related to concession
    setRowConcessions({});
    setEditableMonths({});
    setUpdatedFSData(null);
  }
}, [forConcession]);
useEffect(() => {
  const fetchNextRollNo = async () => {
    if (!studentData.session || !studentData.class || !studentData.section) return;

    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/students/getStudents`,
        {
          params: {
            sessionId: studentData.session,
            class: studentData.class,
            section: studentData.section,
             includeNextRollNo: true
          },
        }
      );

      if (res.data?.nextRollNo) {
        setStudentData(prev => ({
          ...prev,
          rollNo: res.data.nextRollNo,
        }));
      }
    } catch (err) {
      console.error("Failed to fetch roll number:", err);
    }
  };

  fetchNextRollNo();
}, [studentData.session, studentData.class, studentData.section]);


  // when user applies a concession on a fee head
const handleRowConcessionApply = async (feeHead, isChecked) => {
  if (!isChecked) return;

  const current = rowConcessions[feeHead];
  if (!current || !current.type || Number(current.amount) <= 0) return;

  // ✅ Update local state first
  const updatedConcessions = {
    ...rowConcessions,
    [feeHead]: {
      ...current,
      applied: true
    }
  };

  setRowConcessions(updatedConcessions);

  // ✅ Send ALL applied concessions (IMPORTANT FIX)
  const payload = {
    feeStructureId: selectedFSData._id,
    concessionData: {
      feeHeadConcessions: Object.fromEntries(
        Object.entries(updatedConcessions)
          .filter(([_, value]) => value?.applied)
          .map(([key, value]) => [
            key,
            {
              concessionName: value.concessionName || "",
              type: value.type,
              amount: Number(value.amount)
            }
          ])
      )
    }
  };

  try {
    console.log("🚀 Sending payload:", payload);

    const { data } = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/api/concession/calculate`,
      payload
    );

    if (data.success) {
      setUpdatedFSData(data.updatedFeeStructure || data.updatedLedger);
    }
  } catch (error) {
    console.error("Concession apply error:", error);
  }
};





  //hdjdashdj

  useEffect(() => {
    const fetchHeads = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/concession/admissionConcession`,
          {
            params: {
              sessionId: localStorage.getItem("currentSessionId"),
              className: selectedClass,
              sections: selectedSection,
            }
          }
        );
        setHeads(res.data || []);
        console.log("Fetched heads:", res.data);
      } catch (err) {
        console.error("Error fetching heads:", err);
      }
    };

    fetchHeads();
  }, [selectedClass, selectedSection]);


  useEffect(() => {
    const fetchSectionsAndFeeStructures = async () => {
      // Fetch sections
      if (selectedClass) {
        try {
          const res = await axios.get(
            ` ${process.env.REACT_APP_API_BASE_URL}/api/sections/${selectedClass}/getSectionsByClassName`
          );
          setSections(res.data);
        } catch (error) {
          console.error("Error fetching sections:", error);
        }
      } else setSections([]);

      // Fetch fee structures
      if (selectedClass) {
        try {
          const res = await axios.get(
            ` ${process.env.REACT_APP_API_BASE_URL}/api/feeStructures/getFeeStructureByClass/${selectedClass}`,
            { params: { studentType: "New Student", medium: "English" } }
          );

          // If API returns { data: [...] }, use res.data.data
          setFeeStructures(Array.isArray(res.data) ? res.data : res.data.data);
        } catch (error) {
          console.error("Error fetching fee structures:", error);
          setFeeStructures([]);
        }
      } else setFeeStructures([]);
    };

    fetchSectionsAndFeeStructures();
  }, [selectedClass]);

  // Fetch classes when session changes
  useEffect(() => {
    if (!studentData.session) {
      setClasses([]);
      setStudentData((prev) => ({ ...prev, class: "", section: "" }));
      return;
    }

    axios
      .get(` ${process.env.REACT_APP_API_BASE_URL}/api/classes/getClasses?sessionId=${studentData.session}`)
      .then((res) => setClasses(res.data))
      .catch((err) => console.error("Error fetching classes:", err));
  }, [studentData.session]);

  // Fetch sections when class changes
  useEffect(() => {
    if (!studentData.class) {
      setSections([]);
      setStudentData((prev) => ({ ...prev, section: "" }));
      return;
    }

    axios
      .get(
        ` ${process.env.REACT_APP_API_BASE_URL}/api/sections/${encodeURIComponent(
          studentData.class
        )}/getSectionsByClassName?sessionId=${studentData.session}`
      )
      .then((res) => {
        const sectionData = Array.isArray(res.data) ? res.data : res.data.sections || [];
        setSections(sectionData);
      })
      .catch((err) => {
        console.error("Error fetching sections:", err);
        setSections([]);
      });
  }, [studentData.class, studentData.session]);

  // Fetch fee structures when class changes
  const fetchFeeStructures = async () => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/feeStructures/getFeeStructureByClass`,
        {
          params: {
            className: studentData.class,
            sessionId: studentData.session,
            studentType: studentData.studentType || "ALL",
            studentId: studentData._id || null,
          },
        }
      );
      setFeeStructures(data || []);
    } catch {
      setFeeStructures([]);
    }
  };

  useEffect(() => {
    if (!studentData.class || !studentData.session) {
      setFeeStructures([]);
      return;
    }
    fetchFeeStructures();
  }, [
    studentData.class,
    studentData.session,
    studentData.studentType
  ]);

  // Fetch bus routes on mount
  useEffect(() => {
    axios
      .get(` ${process.env.REACT_APP_API_BASE_URL}/api/busroutes/getBusRoutes?sessionId=${localStorage.getItem("currentSessionId")}`)
      .then((res) => setBusRoutes(res.data))
      .catch((err) => console.error(err));
  }, []);


  // Fetch locations when routeName changes
  useEffect(() => {
    if (!selectedRouteId) {
      setLocations([]);
      return;
    }

    const sessionId = localStorage.getItem("currentSessionId");
    if (!sessionId) return;

    axios
      .get(
        ` ${process.env.REACT_APP_API_BASE_URL}/api/locations/${selectedRouteId}/getAllBusLocations`,
        { params: { sessionId } }
      )
      .then((res) => {
        console.log("Fetched locations:", res.data);
        setLocations(res.data);
      })
      .catch((err) => console.error(err));
  }, [selectedRouteId]);


  // Fetch route charges when location or routeType changes
  useEffect(() => {
    if (!studentData.location) {
      setExistingCharges(0);
      setStudentData((prev) => ({ ...prev, routeCharges: 0 }));
      return;
    }

    axios
      .get(` ${process.env.REACT_APP_API_BASE_URL}/api/routeCharges/getRouteChargesByLocation/${studentData.location}`, { params: { sessionId: studentData.session } })
      .then((res) => {
        let total = res.data.totalFees || 0;
        if (studentData.routeType === "one-way") total /= 2;
        setExistingCharges(total);
        setStudentData((prev) => ({ ...prev, routeCharges: total }));
      })
      .catch((err) => console.error(err));
  }, [studentData.location, studentData.routeType]);

  // Calculate age
  const calculateAge = (dob) => {
    const birth = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birth.getFullYear();
    const diff = today.getMonth() - birth.getMonth();
    if (diff < 0 || (diff === 0 && today.getDate() < birth.getDate())) age--;
    return age;
  };

  // Generate username and password
  useEffect(() => {
    if (studentData.firstName && studentData.class && studentData.dob && !studentData.username) {
      const year = new Date(studentData.dob).getFullYear();
      const random = Math.floor(1000 + Math.random() * 9000);
      const username = `${studentData.firstName}${year}${studentData.class}`;
      const password = `${studentData.firstName}${random}`;
      setStudentData((prev) => ({ ...prev, username, password }));
    }
  }, [studentData.firstName, studentData.class, studentData.dob, studentData.username]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log("Changed:", name, value); // <-- see what is being selected
    setStudentData((prev) => ({
      ...prev,
      [name]: value,
      age: name === "dob" ? calculateAge(value) : prev.age,
    }));
  };


  const handleFileChange = (e) => {
    setStudentData((prev) => ({ ...prev, image: e.target.files[0] }));
  };
const resetAllState = () => {
  setIsSubmitted(false);

  // Student + form
  setStudentData(initialStudentData);
  setSelectedClass("");
  setSelectedSection("");
  setEditCredentials(false);
  
  // RESET IMAGE + CAMERA
  setPreviewImage(null);
  setShowCamera(false);
  
  // Fee & concession
  setSelectedFSData(null);
  setUpdatedFSData(null);
  setForConcession(false);
  setRowConcessions({});
  setEditableMonths({});
  setConcessionRows([]);
  setAppliedConcessions([]);
  setFeeHeadConcessions({});
  setOverallConcessionAmount(0);
  setOverallConcessionPercent(0);

  // Lists
  setClasses([]);
  setSections([]);
  setFeeStructures([]);
  setHeads([]);

  // Transport
  setSelectedRouteId("");
  setLocations([]);
  setExistingCharges(0);
  setRouteMonthlyFees(null);

  // Filters / misc
  setSelectedFeeStructure("");
};

  const handleSubmit = async (e) => {
  e.preventDefault();

  if (!studentData.feeStructureId) {
    alert("Please select a fee structure");
    return;
  }

  if (studentData.aadhaarNumber) {
    const aadhaarRegex = /^\d{12}$/;
    if (!aadhaarRegex.test(studentData.aadhaarNumber)) {
      alert("Aadhaar number must be exactly 12 digits");
      setLoading(false);
      return;
    }
  }

  setLoading(true);
  const formData = new FormData();

  for (const key in studentData) {
    const value = studentData[key];
    if (value !== null && value !== undefined && value !== "") {
      formData.append(key, key === "image" ? value : value.toString());
    }
  }

  try {
    // 1️⃣ Create Student
    const studentRes = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/api/students/createStudent`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    alert("Student created successfully!");
    const student = studentRes.data.student;
    if (
  studentData.transportationMode === "schoolVan" &&
  studentData.busNumber
) {
  try {
    const sessionId = student.session;

    await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/api/busSchedules/allocateStudentsToBus/${studentData.busNumber}?session=${sessionId}`,
      {
        allocationDate: new Date(),

        students: [
          {
            _id: student._id,
            name: `${student.firstName} ${student.lastName}`,
            class: student.class,
            section: student.section,
            route: studentData.routeName,
            location: studentData.location
          }
        ]
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        }
      }
    );

  } catch (err) {
    console.error(err);
  }
}

    // ================================
    // ✅ BUILD FINAL feeHeads CORRECTLY
    // ================================

    // 🔥 Always start from original fee structure
    const feeHeads = {
      ...(selectedFSData?.feeHeadValues || {}),
    };

    // 🔥 Override only if concession calculated
    if (updatedFSData?.feeHeadValues) {
      Object.entries(updatedFSData.feeHeadValues).forEach(
        ([key, value]) => {
          feeHeads[key] = value;
        }
      );
    }

    // 🔥 Monthly fees (always ensure correct values)
    for (let i = 1; i <= 12; i++) {
      feeHeads[`month${i}`] =
        editableMonths[`month${i}`] ??
        updatedFSData?.[`month${i}`] ??
        selectedFSData?.[`month${i}`] ??
        0;
    }

    // ================================
    // ✅ BUILD feeHeadConcessions ARRAY
    // ================================
    const feeHeadConcessions = Object.entries(rowConcessions)
      .filter(([_, v]) => v?.applied)
      .map(([feeHead, v]) => {
        if (feeHead === MONTHLY_FEE_KEY) {
          return Array.from({ length: 12 }, (_, i) => ({
            feeHead: `month${i + 1}`,
            concessionType: v.type,
            concessionAmount: v.amount
          }));
        }

        return {
          feeHead,
          concessionName: v.concessionName,
          concessionType: v.type,
          concessionAmount: v.amount
        };
      })
      .flat();

    // ================================
    // 2️⃣ Create Ledger
    // ================================
    await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/api/ledgers/createLedger`,
      {
        studentId: student._id,
        feeStructureId: studentData.feeStructureId,
        sessionId: student.session,

        totalAmount: selectedFSData?.totalfees,
        totalAmountAfterConcession: updatedFSData?.totalfees,

        routeMonthlyFees,
        feeHeadConcessions,
        feeHeads
      }
    );

    // Reset form
    resetAllState();

  } catch (error) {
    console.error(
      "Error creating student:",
      error.response?.data || error.message
    );
  } finally {
    setLoading(false);
  }
};


  const labelStyle = "text-black font-semibold mb-1 !text-[18px]";
  const inputStyle =
    "border rounded-lg px-3 py-2 outline-none !text-[14px] placeholder:!text-[14px] focus:ring-2 focus:ring-blue-500";

 

  useEffect(() => {
    if (!updatedFSData) return;

    const synced = {};

    // Fee head values
    if (updatedFSData.feeHeadValues) {
      Object.entries(updatedFSData.feeHeadValues).forEach(
        ([key, value]) => {
          synced[key] = value;
        }
      );
    }

    // Monthly fee months
    for (let i = 1; i <= 12; i++) {
      if (updatedFSData[`month${i}`] !== undefined) {
        synced[`month${i}`] = updatedFSData[`month${i}`];
      }
    }

    setEditableMonths(prev => ({
      ...prev,
      ...synced, // backend wins
    }));
  }, [updatedFSData]);
useEffect(() => {
  if (!rawRouteMonthlyFees || !studentData.routeType) {
    setRouteMonthlyFees(null);
    return;
  }

  const adjusted = {};

  Object.entries(rawRouteMonthlyFees).forEach(([key, value]) => {
    adjusted[key] =
      studentData.routeType === "one-way"
        ? Number(value) / 2
        : Number(value);
  });

  setRouteMonthlyFees(adjusted); // ✅ FINAL truth
}, [rawRouteMonthlyFees, studentData.routeType]);



  return (
    <div className="container mx-auto p-6 bg-white shadow-lg rounded-lg">
      <form onSubmit={handleSubmit} className="space-y-6">
        {/* First Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {[
            { label: "First Name", name: "firstName", placeholder: "Enter first name" },
            { label: "Last Name", name: "lastName", placeholder: "Enter last name" },
            { label: "Gender", name: "gender", type: "select" },
            { label: "Email", name: "email", placeholder: "Enter email" },
            { label: "Date of Birth", name: "dob", type: "date" },
            { label: "Age", name: "age", type: "number", placeholder: "Calculated automatically" },
            { label: "State", name: "state", placeholder: "Enter state" },
            { label: "City", name: "city", placeholder: "Enter city" },
            { label: "Address", name: "address", placeholder: "Enter address" },
            { label: "Previous Year Result", name: "previousYearResult", placeholder: "Enter result" },
          ].map(({ label, name, type = "text", placeholder }) => (
            <div key={name} className="flex flex-col">
              <label className={labelStyle}>{label}:</label>
              {type === "select" ? (
                <select name={name} value={studentData[name]} onChange={handleChange} className={inputStyle}>
                  <option value="">Select gender</option>
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                  <option value="others">Others</option>
                </select>
              ) : (
                <input
                  type={type}
                  name={name}
                  value={studentData[name]}
                  onChange={handleChange}
                  placeholder={placeholder}
                  className={inputStyle}
                />
              )}
            </div>
          ))}
        </div>

        {/* Second Grid: Parents, Phone, Image, Category, Financial, Status */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="flex flex-col">
            <label className={labelStyle}>Father's Name:</label>
            <input type="text" name="fatherName" value={studentData.fatherName} onChange={handleChange} placeholder="Enter father's name" className={inputStyle} />
          </div>
          <div className="flex flex-col">
            <label className={labelStyle}>Mother's Name:</label>
            <input type="text" name="motherName" value={studentData.motherName} onChange={handleChange} placeholder="Enter mother's name" className={inputStyle} />
          </div>
         
<div className="flex flex-col">
  <label className={labelStyle}>Aadhaar Number:</label>
  <input
    type="text"
    name="aadhaarNumber"
    value={studentData.aadhaarNumber}
    onChange={(e) => {
      const value = e.target.value.replace(/\D/g, ""); // allow only digits
      if (value.length <= 12) {
        setStudentData(prev => ({
          ...prev,
          aadhaarNumber: value
        }));
      }
    }}
    placeholder="Enter 12-digit Aadhaar number"
    className={inputStyle}
    maxLength={12}
  />
</div>


          <div className="flex flex-col">
            <label className={labelStyle}>Phone No:</label>
            <input type="text" name="phoneNo" value={studentData.phoneNo} onChange={handleChange} placeholder="Enter phone" className={inputStyle} />
          </div>
          <div className="flex flex-col">
            <label className={labelStyle}>Phone No 2:</label>
            <input type="text" name="phoneNo2" value={studentData.phoneNo2} onChange={handleChange} placeholder="Enter phone" className={inputStyle} />
          </div>
          <div className="flex flex-col">
  <label className={labelStyle}>Student Photo:</label>

  {/* File Upload */}
  <input
    type="file"
    accept="image/*"
    onChange={(e) => {
      handleFileChange(e);
      setPreviewImage(URL.createObjectURL(e.target.files[0]));
    }}
    className={inputStyle}
  />

  {/* Open Camera Button */}
  <button
    type="button"
    className="mt-2 bg-green-600 text-white px-3 py-1 rounded"
    onClick={() => setShowCamera(true)}
  >
    Capture from Webcam
  </button>

  {/* Camera Modal */}
  {showCamera && (
    <div className="mt-4">
      <Webcam
  ref={webcamRef}
  screenshotFormat="image/jpeg"
  videoConstraints={{
    facingMode: "user",
    deviceId: undefined
  }}
  className="rounded-lg"
/>
      <button
        type="button"
        className="mt-2 bg-blue-600 text-white px-3 py-1 rounded"
        onClick={capturePhoto}
      >
        Take Photo
      </button>
    </div>
  )}

  {/* Preview */}
  {previewImage && (
    <img
      src={previewImage}
      alt="Preview"
      className="mt-3 w-32 h-32 object-cover rounded-lg border"
    />
  )}
</div>
          <div className="flex flex-col">
            <label className={labelStyle}>Select Category:</label>
            <select name="category" value={studentData.category} onChange={handleChange} className={inputStyle} required>
              <option value="">Select Category</option>
              <option value="General">General</option>
              <option value="SC">SC</option>
              <option value="ST">ST</option>
              <option value="OBC">OBC</option>
              <option value="Minority">Minority</option>
              <option value="Any Other">Any Other</option>
            </select>
          </div>
          <div className="flex flex-col">
            <label className={labelStyle}>Financial Category:</label>
            <select name="financial" value={studentData.financial} onChange={handleChange} className={inputStyle} required>
              <option value="">Select Financial Category</option>
              <option value="apl">APL</option>
              <option value="bpl">BPL</option>
              <option value="ews">EWS</option>
              <option value="mpl">MPL</option>
              <option value="lig">LIG</option>
              <option value="mig">MIG</option>
              <option value="hig">HIG</option>
              <option value="ultrapoor">Ultra-Poor</option>
            </select>
          </div>
          <div className="flex flex-col">
            <label className={labelStyle}>Student Status:</label>
            <select name="status" value={studentData.status} onChange={handleChange} className={inputStyle} required>
              <option value="active">Active</option>
              <option value="deactive">Deactive</option>
            </select>
          </div>
        </div>

        {/* Session, Class, Section */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="flex flex-col">
            <label className={labelStyle}>Session</label>
            <select name="session" value={studentData.session} onChange={handleChange} className={inputStyle} required>
              <option value="">Select Session</option>
              {sessions.map((s) => (
                <option key={s._id} value={s._id}>{s.sessionName}</option>
              ))}
            </select>
          </div>
          <div className="flex flex-col">
            <label className={labelStyle}>Class</label>
            <select
  name="class"
  value={studentData.class}
  onChange={(e) => {
    handleChange(e);
  }}

              className={inputStyle}
              disabled={!studentData.session}
              required
            >

              <option value="">Select Class</option>
              {classes.map((c) => (
                <option key={c._id} value={c.className}>{c.className}</option>
              ))}
            </select>
          </div>
          <div className="flex flex-col">
            <label className={labelStyle}>Section</label>
            <select name="section" value={studentData.section} onChange={(e) => {
              handleChange(e);
              setSelectedSection(e.target.value);
            }} className={inputStyle} disabled={!studentData.class} required>
              <option value="">Select Section</option>
              {sections.map((sec) => (
                <option key={sec._id} value={sec.sectionName}>{sec.sectionName}</option>
              ))}
            </select>
          </div>
        </div>

        {/* RollNo, Username, Password, Fee Structure */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          <div className="flex flex-col">
            <label className={labelStyle}>Roll No:</label>
            <input
  type="number"
  name="rollNo"
  value={studentData.rollNo}
  disabled
  className={inputStyle}
/>

          </div>
          
          <div className="flex flex-col">
            <label className={labelStyle}>Select Fee Structure:</label>
            <select name="feeStructureId" value={studentData.feeStructureId} onChange={(e) => {
              const id = e.target.value;
              setStudentData((prev) => ({ ...prev, feeStructureId: id }));
              const fs = feeStructures.find((item) => item._id === id);
              setSelectedFSData(fs || null);
            }} className={inputStyle} required>
              <option value="">Select Fee Structure</option>
              {feeStructures.map((fs) => (
               <option key={fs._id} value={fs._id}>
  {fs.studentType} — {fs.medium} | Class {fs.class || fs.className}
</option>

              ))}
            </select>
          </div>
        </div>
<div className="grid grid-cols-1 md:grid-cols-3 gap-6">
  {/* Username */}
  <div className="flex flex-col">
    <label className={labelStyle}>Username:</label>
    <input
      type="text"
      name="username"
      value={studentData.username}
      onChange={handleChange}
      disabled={!editCredentials}
      className={inputStyle}
    />
  </div>

  {/* Password */}
  <div className="flex flex-col">
    <label className={labelStyle}>Password:</label>
    <input
      type="text"
      name="password"
      value={studentData.password}
      onChange={handleChange}
      disabled={!editCredentials}
      className={inputStyle}
    />
  </div>

  {/* Edit / Save Button */}
  <div className="flex items-end">
    <button
      type="button"
      className={`px-4 py-2 rounded-lg text-white ${
        editCredentials ? "bg-green-600" : "bg-gray-600"
      }`}
      onClick={() => setEditCredentials(prev => !prev)}
    >
      {editCredentials ? "Save" : "Edit"}
    </button>
  </div>
</div>

        {/* Transportation */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="flex flex-col">
            <label className={labelStyle}>Transportation Mode:</label>
            <select name="transportationMode" value={studentData.transportationMode} onChange={handleChange} className={inputStyle} required>
              <option value="">Select mode</option>
              <option value="self">Self</option>
              <option value="parents">Parents</option>
              <option value="schoolVan">School Van</option>
            </select>
          </div>

          {studentData.transportationMode === "schoolVan" && (
            <>
              <div className="flex flex-col">
                <label className={labelStyle}>Route Type:</label>
                <select name="routeType" value={studentData.routeType} onChange={handleChange} className={inputStyle} required>
                  <option value="">Select Route Type</option>
                  <option value="two-way">Two-way</option>
                  <option value="one-way">One-way</option>
                </select>
              </div>
              <div className="flex flex-col">
                <label className={labelStyle}>Route Name:</label>
                <select
                  name="routeName"
                  value={studentData.routeName}
                  onChange={(e) => {
                    const selectedRoute = busRoutes.find(
                      (r) => r.routeName === e.target.value
                    );
                    if (selectedRoute) {
                      setSelectedRouteId(selectedRoute._id); // store route ID for fetching locations
                    } else {
                      setSelectedRouteId("");
                    }
                    handleChange(e); // update studentData.routeName
                  }}
                  className={inputStyle}
                  required
                >
                  <option value="">Select Route</option>
                  {busRoutes.map((route) => (
                    <option key={route._id} value={route.routeName}>
                      {route.routeName}
                    </option>
                  ))}
                </select>

              </div>
              <div className="flex flex-col">
                <label className={labelStyle}>Location:</label>
                <select
                  name="location"
                  value={studentData.location}
                  onChange={handleChange}
                  className={inputStyle}
                  required
                >
                  <option value="">Select Location</option>
                  {locations.map((loc) => (
                    <option key={loc._id} value={loc.location}>
                      {loc.location} {/* matches your API */}
                    </option>
                  ))}
                </select>


              </div>
              <div className="flex flex-col">
  <label className={labelStyle}>Select Bus:</label>

  <select
    name="busNumber"
    value={studentData.busNumber || ""}
    onChange={handleChange}
    className={inputStyle}
    required
    disabled={studentData.transportationMode !== "schoolVan"}
  >
    <option value="">Select Bus</option>

    {buses.map((bus) => (
      <option key={bus._id} value={bus.busNumber}>
        {bus.busNumber}
      </option>
    ))}
  </select>
</div>
              <div className="flex flex-col">
                <label className={labelStyle}>Route Charges:</label>
                <input type="number" name="routeCharges" value={studentData.routeCharges} disabled className={inputStyle} />
              </div>
            </>
          )}
        </div>

        <Feetable
  studentData={studentData}
  feeStructures={feeStructures}
  selectedFSData={selectedFSData}
  months={months}
  forConcession={forConcession}
  setForConcession={setForConcession}
  rowConcessions={rowConcessions}
  setRowConcessions={setRowConcessions}
  editableMonths={editableMonths}
  setEditableMonths={setEditableMonths}
  updatedFSData={updatedFSData}
  handleRowConcessionApply={handleRowConcessionApply}
  heads={heads}
  MONTHLY_FEE_KEY={MONTHLY_FEE_KEY}
   routeMonthlyFees={routeMonthlyFees}
    concessionAllowed={concessionAllowed}          // ✅ ADD
  concessionMessage={concessionMessage} 
/>




        <div className="flex justify-start gap-10">
          <button type="submit" className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg !text-[14px]" disabled={loading}>
            {loading ? "Submitting..." : "Submit"}
          </button>
         <button
  type="button"
  className="bg-red-600 hover:bg-red-400 text-white px-4 py-2 rounded-lg !text-[14px]"
  onClick={resetAllState}
>
  Reset
</button>

        </div>
      </form>
    </div>
  );
};

export default NewStudent;